
import ReqClient from './request.class'

// 批量新建uc广告
/**
 * @description:
 * @param {*} data
 * @return {*}
 */
export async function addUcBatch (data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/batchuc',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 校验uc组名与计划名称是否重复
 * @param {*} data {name: '', type: 1, adAccountId: ''} type(1 广告组 ，2计划)
 */
export async function checkName (data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/checkNameExist',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: uc 安卓 ios 校验
 * @param {*} data
 * @return {*}
 */
export async function checkGameInfo (data) {
  const Req = new ReqClient({
    url: '/api/ptom/appinfo/getGameInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
